<template>
  <div id="app">
    <h1>Memorama</h1>
    <Board/>
    <GameOver/>
  </div>
</template>

<script>
import Board from "./Board";
import GameOver from "./GameOver";

export default {
  name: "app",
  components: {
    Board,
    GameOver
  }
};
</script>

<style>
body {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#app {
  background: #fff;
}
h1 {
  font-weight: 300;
  color: #7a11fe;
}
</style>
